//menuName:'订单'            //菜单权限名称
//menuPermission:'order'    //菜单权限
import Vue from 'vue'
export default [
    {
        path: '/',
        meta: {},
        component: () => import('@/views/index')
    },
    {
        path: '/order/refund-detail/:id',
        meta: {
            title: '退款记录',
            menuName: '退款记录',
            menuPermission: 'order'
        },
        component: () => import('@/views/order/refund-detail')
    },
    // ==========================================================  店员  ==========================================================
    {
        path: '/clerk/order/list',
        meta: {
            title: '我的订单',
            menuName: '订单',
            menuPermission: 'order'
        },
        component: () => import('@/views/clerk/order/order-list')
    },
    {
        path: '/clerk/order/out-order-list',
        meta: {
            title: '外部订单',
            menuName: '外部订单',
            menuPermission: 'out-order'
        },
        component: () => import('@/views/clerk/order/out-order-list')
    },
    {
        path: '/clerk/out_first_order/list',
        meta: {
            title: '首单体验',
            menuName: '首单体验',
            menuPermission: 'first-order'
        },
        component: () => import('@/views/clerk/out_first_order/list')
    },
    {
        path: '/clerk/order/detail/:id',
        meta: {
            title: '订单详情',
            menuName: '订单',
            menuPermission: 'order'
        },
        component: () => import('@/views/clerk/order/order-detail')
    },
    {
        path: '/clerk/order/orderComment/:id',
        meta: {
            title: '订单反馈',
            menuName: '订单',
            menuPermission: 'order'
        },
        component: () => import('@/views/clerk/order/orderComment')
    },
    {
        path: '/clerk/dispatchOrder/list',
        meta: {
            title: '派单列表',
            menuName: '派单列表',
            menuPermission: 'dispatchOrder'
        },
        component: () => import('@/views/clerk/dispatchOrder/order-list')
    },
    {
        path: '/clerk/dispatchOrder/detail/:id',
        meta: {
            title: '派单详情',
            menuName: '派单详情',
            menuPermission: 'dispatchOrder'
        },
        component: () => import('@/views/clerk/dispatchOrder/order-detail')
    },
    {
        path: '/clerk/dispatchOrder/uploadDispatch',
        meta: {
            title: '上传订单',
            menuName: '上传订单',
            menuPermission: 'uploadDispatchOrder'
        },
        component: () => import('@/views/clerk/dispatchOrder/order-upload')
    },
    {
        path: '/clerk/dispatchOrder/uploadOutDispatch',
        meta: {
            title: '上传外派订单',
            menuName: '上传外派订单',
            menuPermission: 'uploadOutDispatchOrder'
        },
        component: () => import('@/views/clerk/dispatchOrder/out-order-upload')
    },
    {
        path: '/clerk/wages',
        meta: {
            title: '我的工资',
            menuName: '工资',
            menuPermission: 'wages'
        },
        component: () => import('@/views/clerk/wages')
    },
    {
        path: '/clerk/wages-detail',
        meta: {
            title: '工资明细',
            menuName: '工资明细',
            menuPermission: 'wages'
        },
        component: () => import('@/views/clerk/wages-detail')
    },
    {
        path: '/clerk/ranking-list',
        meta: {
            title: '我的排名',
            menuName: '我的排名',
            menuPermission: 'ranking-list'
        },
        component: () =>{
            if(Vue.prototype.$hasFeature('custom_47')){
                return import('@/views/47/clerk/ranking-list')
            }
            return import('@/views/clerk/ranking-list')
        }
    },
    {
        path: '/clerk/reward-log',
        meta: {
            title: '打赏动态',
            menuName: '打赏动态',
            menuPermission: 'reward-log'
        },
        component: () => import('@/views/clerk/reward-log')
    },
    {
        path: '/clerk/post/list',
        meta: {
            title: '发布动态',
            menuName: '发布动态',
            menuPermission: 'post-list'
        },
        component: () => import('@/views/clerk/post/post-list')
    },
    {
        path: '/clerk/post/detail/:id',
        meta: {
            title: '动态详情',
            menuName: '发布动态',
            menuPermission: 'post-list'
        },
        component: () => import('@/views/clerk/post/post-detail')
    },
    {
        path: '/clerk/post/add',
        meta: {
            title: '添加动态',
            menuName: '发布动态',
            menuPermission: 'post-list'
        },
        component: () => import('@/views/clerk/post/post-add')
    },
    {
        path: '/clerk/post/update/:id',
        meta: {
            title: '修改动态',
            menuName: '发布动态',
            menuPermission: 'post-list'
        },
        component: () => import('@/views/clerk/post/post-update')
    },
    {
        path: '/clerk/auto/online',
        meta: {
            title: '自动在线',
            menuName: '自动在线',
            menuPermission: 'auto-online'
        },
        component: () => import('@/views/clerk/auto/online')
    },
    {
        path: '/clerk/random',
        meta: {
            title: '随机订单',
            menuName: '抢单大厅',
            menuPermission: 'random'
        },
        component: () => import('@/views/clerk/random')
    },
    {
        path: '/clerk/add',
        meta: {
            title: '添加店员'
        },
        component: () => import('@/views/clerk/add')
    },
    {
        path: '/clerk/grade',
        meta: {
            title: '我的等级',
            menuName: '我的等级',
            menuPermission: 'grade'
        },
        component: () => import('@/views/clerk/grade')
    },
    {
        path: '/clerk/info',
        meta: {
            title: '我的资料',
            menuName: '我的资料',
            menuPermission: 'info'
        },
        component: () => import('@/views/clerk/info')
    },
    {
        path: '/clerk/clerkCategory',
        meta: {
            title: '我的技能',
            menuName: '我的技能',
            menuPermission: 'clerkCategory'
        },
        component: () => import('@/views/clerk/clerkCategory')
    },
    {
        path: '/clerk/updateAvatarUrl',
        meta: {
            title: '修改头像',
            menuName: '我的资料',
            menuPermission: 'info'
        },
        component: () => import('@/views/clerk/updateAvatarUrl')
    },
    {
        path: '/clerk/updateItemType',
        meta: {
            title: '修改服务类型',
            menuName: '我的资料',
            menuPermission: 'info'
        },
        component: () => import('@/views/clerk/updateItemType')
    },
    {
        path: '/clerk/updatePhotos',
        meta: {
            title: '修改相册',
            menuName: '我的资料',
            menuPermission: 'info'
        },
        component: () => import('@/views/clerk/updatePhotos')
    },
    {
        path: '/clerk/uploadVideo',
        meta: {
            title: '修改视频',
            menuName: '我的资料',
            menuPermission: 'info'
        },
        component: () => import('@/views/clerk/uploadVideo')
    },
    {
        path: '/clerk/gamingInfo',
        meta: {
            title: '修改电竞资料',
            menuName: '我的资料',
            menuPermission: 'info'
        },
        component: () => import('@/views/clerk/gamingInfo')
    },
    {
        path: '/clerk/updateTags',
        meta: {
            title: '修改标签',
            menuName: '我的资料',
            menuPermission: 'info'
        },
        component: () => import('@/views/clerk/updateTags')
    },
    {
        path: '/clerk/updateCharacteristic',
        meta: {
            title: '修改特质',
            menuName: '我的资料',
            menuPermission: 'info'
        },
        component: () => import('@/views/clerk/updateCharacteristic')
    },
    {
        path: '/clerk/updateAudio',
        meta: {
            title: '修改音频',
            menuName: '我的资料',
            menuPermission: 'info'
        },
        component: () => import('@/views/clerk/updateAudio')
    },
    {
        path: '/clerk/updateSound',
        meta: {
            title: '修改声音',
            menuName: '我的资料',
            menuPermission: 'info'
        },
        component: () => import('@/views/clerk/updateSound')
    },
    {
        path: '/clerk/updateCategory',
        meta: {
            title: '修改分类',
            menuName: '我的资料',
            menuPermission: 'info'
        },
        component: () => import('@/views/clerk/updateCategory')
    },
    {
        path: '/clerk/item-price',
        meta: {
            title: '服务价格',
            menuName: '服务价格',
            menuPermission: 'item-price'
        },
        component: () => import('@/views/clerk/item-price')
    },
    {
        path: '/clerk/clerk-category-apply-list',
        meta: {
            title: '技能申请',
            menuName: '技能申请',
            menuPermission: 'clerk_category_apply'
        },
        component: () => import('@/views/clerk/clerkCategory/clerk-category-apply-list')
    },
    {
        path: '/clerk/categoryExamineApply',
        meta: {
            title: '技能申请',
            menuName: '技能申请',
            menuPermission: 'clerk_category_apply'
        },
        component: () => import('@/views/clerk/clerkCategory/category-examine-apply')
    },
    {
        path: '/clerk/clerk-category-apply-detail/:id',
        meta: {
            title: '技能申请详情',
            menuName: '技能申请详情',
            menuPermission: 'clerk_category_apply'
        },
        component: () => import('@/views/clerk/clerkCategory/clerk-category-apply-detail')
    },
    {
        path: '/clerk/clerk-category-grade',
        meta: {
            title: '技能等级',
            menuName: '技能等级',
            menuPermission: 'clerk_category_apply'
        },
        component: () => import('@/views/clerk/clerkCategory/clerk-category-grade')
    },

    {
        path: '/clerk/clerk-houtai',
        meta: {
            title: '店员后台',
            menuName: '店员中心',
            menuPermission: 'clerk-houtai'
        },
        component: () => import('@/views/clerk/clerk-houtai')
    },
    {
        path: '/clerk/clerk-user',
        meta: {
            title: '店员中心',
            menuName: '店员中心',
            menuPermission: 'clerk-houtai'
        },
        component: () => import('@/views/clerk/clerk-user')
    },
    {
        path: '/clerk/gift',
        meta: {
            title: '我的礼物',
            menuName: '我的礼物',
            menuPermission: 'gift'
        },
        component: () => import('@/views/clerk/gift')
    },
    {
        path: '/clerk/performance',
        meta: {
            title: '我的业绩',
            menuName: '我的业绩',
            menuPermission: 'my-performance'
        },
        component: () => import('@/views/clerk/performance')
    },
    {
        path: '/clerk/clerkRespondUser/list',
        meta: {
            title: '呼叫店员',
            menuName: '呼叫店员',
            menuPermission: 'order'
        },
        component: () => import('@/views/clerk/clerkRespondUser/list')
    },
    {
        path: '/clerk/clerkRespondUser/detail/:id',
        meta: {
            title: '呼叫店员详情',
            menuName: '呼叫店员详情',
            menuPermission: 'order'
        },
        component: () => import('@/views/clerk/clerkRespondUser/detail')
    },
    {
        path: '/clerk/dispatchOrder/updateGameSetting',
        meta: {
            title: '游戏管理',
            menuName: '游戏管理',
            menuPermission: 'dispatchOrder'
        },
        component: () => import('@/views/clerk/dispatchOrder/updateGameSetting')
    },
    {
        path: '/clerk/dispatchOrder/soundCard',
        meta: {
            title: '音卡',
            menuName: '音卡',
            menuPermission: 'dispatchOrder'
        },
        component: () => import('@/views/clerk/dispatchOrder/soundCard')
    },
    {
        path: '/clerk/chat/roomInfo',
        meta: {
            title: '聊天',
            menuName: '聊天',
            menuPermission: 'chat'
        },
        component: () => import('@/views/2184/clerk/chat/roomInfo.vue')
    },
    {
        path: '/clerk/chat/roomList',
        meta: {
            title: '聊天消息',
            menuName: '聊天',
            menuPermission: 'chat'
        },
        component: () => import('@/views/2184/clerk/chat/roomList')
    },
    {
        path: '/clerk/chat/onlineList',
        meta: {
            title: '在线客户',
            menuName: '聊天',
            menuPermission: 'chat'
        },
        component: () => import('@/views/2184/clerk/chat/onlineList')
    },
    {
        path: '/clerk/sign-in',
        meta: {
            title: '积分',
            menuName: '积分',
            menuPermission: 'clerk_point'
        },
        component: () => import('@/views/clerk/point/sign-in')
    },
    {
        path: '/clerk/signInDetail',
        meta: {
            title: '积分明细',
            menuName: '积分',
            menuPermission: 'clerk_point',
        },
        component: () => import('@/views/clerk/point/signInDetail')
    },
    {
        path: '/clerk/signInRule',
        meta: {
            title: '规则',
            menuName: '积分',
            menuPermission: 'clerk_point'
        },
        component: () => import('@/views/clerk/point/signInRule')
    },
    {
        path: '/clerk/clerk-pk',
        meta: {
            title: '我的Pk',
            menuName: '店员PK',
            menuPermission: 'clerk_pk'
        },
        component: () => import('@/views/clerk/point/clerk-pk')
    },
    {
        path: '/clerk/clerk-pk-info/:id',
        meta: {
            title: 'PK详情',
            menuName: '店员PK',
            menuPermission: 'clerk_pk'
        },
        component: () => import('@/views/clerk/point/clerk-pk-info')
    },
    {
        path: '/clerk/order/clerk-order-list',
        meta: {
            title: '权益订单',
            menuName: '权益订单',
            menuPermission: 'clerk-order'
        },
        component: () => import('@/views/clerk/order/clerk-order-list')
    },
    {
        path: '/clerk/order/clerk-order-detail/:id',
        meta: {
            title: '店员权益订单详情',
            menuName: '店员权益订单详情',
            menuPermission: 'clerk-order'
        },
        component: () => import('@/views/clerk/order/clerk-order-detail')
    },

    // ==========================================================  会长  ==========================================================
    {
        path: '/guilder/clerk-apply-list',
        meta: {
            title: '新店员申请',
            menuName: '新店员申请',
            menuPermission: 'clerk-apply'
        },
        component: () => import('@/views/guilder/clerk-apply/clerk-apply-list')
    },
    {
        path: '/guilder/clerk-apply/detail/:id',
        meta: {
            title: '新店员申请详情',
            menuName: '新店员申请',
            menuPermission: 'clerk-apply'
        },
        component: () => import('@/views/guilder/clerk-apply/clerk-apply-detail')
    },
    {
        path: '/guilder/clerk-check/clerk-check-list',
        meta: {
            title: '店员资料审核',
            menuName: '店员资料审核',
            menuPermission: 'clerk-check-list'
        },
        component: () => import('@/views/guilder/clerk-check/clerk-check-list')
    },

    {
        path: '/guilder/clerk-check/detail',
        meta: {
            title: '店员资料审核详情',
            menuName: '店员资料审核',
            menuPermission: 'clerk-check-list'
        },
        component: () => import('@/views/guilder/clerk-check/clerk-check-detail')
    },
    {
        path: '/guilder/clerkPerformance',
        meta: {
            title: '店员业绩',
            menuName: '店员业绩',
            menuPermission: 'clerk-performance'
        },
        component: () => import('@/views/guilder/clerk-performance')
    },
    {
        path: '/guilder/leaderWages',
        meta: {
            title: '组长工资',
            menuName: '组长工资',
            menuPermission: 'leader-wages'
        },
        component: () => import('@/views/guilder/leader_wages')
    },
    {
        path: '/guilder/clerk-category-examine-check',
        meta: {
            title: '店员技能审核',
            menuName: '店员技能审核',
            menuPermission: 'clerk_category_examine_check'
        },
        component: () => import('@/views/guilder/clerk-category-check/clerk-category-check-list')
    },
    {
        path: '/guilder/clerk-category-examine-check-detail',
        meta: {
            title: '店员技能审核详情',
            menuName: '店员技能审核详情',
            menuPermission: 'clerk_category_examine_check'
        },
        component: () => import('@/views/guilder/clerk-category-check/clerk-category-check-detail')
    },
    {
        path: '/guilder/order/detail/:id',
        meta: {
            title: '订单详情',
            menuName: '订单详情',
            menuPermission: 'guilder_order_detail'
        },
        component: () => import('@/views/guilder/order/order-detail')
    },
    {
        path: '/guilder/post-list',
        meta: {
            title: '动态管理',
            menuName: '动态管理',
            menuPermission: 'post-list'
        },
        component: () => import('@/views/guilder/post-list')
    },
    // ==========================================================  组长  ==========================================================

    {
        path: '/leader/wages',
        meta: {
            title: '工资',
            menuName: '工资',
            menuPermission: 'wages'
        },
        component: () => import('@/views/leader/wages')
    },
    {
        path: '/leader/order/list',
        meta: {
            title: '订单列表',
            menuName: '订单',
            menuPermission: 'order'
        },
        component: () => import('@/views/leader/order/order-list')
    },
    {
        path: '/leader/order/detail/:id',
        meta: {
            title: '订单详情',
            menuName: '订单',
            menuPermission: 'order'
        },
        component: () => import('@/views/leader/order/order-detail')
    },
    {
        path: '/leader/order/rate-list',
        meta: {
            title: '订单评价',
            menuName: '订单评价',
            menuPermission: 'order-rate'
        },
        component: () => import('@/views/leader/order/order-rate-list')
    },
    {
        path: '/leader/order/rate-detail/:id',
        meta: {
            title: '订单评价详情',
            menuName: '订单评价',
            menuPermission: 'order-rate'
        },
        component: () => import('@/views/leader/order/order-rate-detail')
    },
    {
        path: '/leader/order/complain-list',
        meta: {
            title: '订单投诉',
            menuName: '订单投诉',
            menuPermission: 'order-complain'
        },
        component: () => import('@/views/leader/order/order-complain-list')
    },
    {
        path: '/leader/order/complain-detail/:id',
        meta: {
            title: '订单投诉详情',
            menuName: '订单投诉',
            menuPermission: 'order-complain'
        },
        component: () => import('@/views/leader/order/order-complain-detail')
    },
    {
        path: '/leader/get_userid',
        meta: {
            title: '获取用户ID'
        },
        component: () => import('@/views/leader/get_userid')
    },
    {
        path: '/leader/clerk-apply-list',
        meta: {
            title: '新店员申请',
            menuName: '新店员申请',
            menuPermission: 'clerk-apply-list'
        },
        component: () => import('@/views/leader/clerk/clerk-apply/clerk-apply-list')
    },
    {
        path: '/leader/clerk-apply/detail/:id',
        meta: {
            title: '新店员申请详情',
            menuName: '新店员申请',
            menuPermission: 'clerk-apply-list'
        },
        component: () => import('@/views/leader/clerk/clerk-apply/clerk-apply-detail')
    },

    {
        path: '/leader/clerk-check/clerk-check-list',
        meta: {
            title: '店员资料审核',
            menuName: '店员资料审核',
            menuPermission: 'clerk-check-list'
        },
        component: () => import('@/views/leader/clerk/clerk-check/clerk-check-list')
    },

    {
        path: '/leader/clerk-check/detail',
        meta: {
            title: '店员资料审核详情',
            menuName: '店员资料审核',
            menuPermission: 'clerk-check-list'
        },
        component: () => import('@/views/leader/clerk/clerk-check/clerk-check-detail')
    },
    {
        path: '/leader/clerk-post-check-list',
        meta: {
            title: '新动态申请列表',
            menuName: '动态审核',
            menuPermission: 'clerk-post-check-list'
        },
        component: () => import('@/views/leader/clerk/clerk-post-check/clerk-post-check-list')
    },
    {
        path: '/leader/continued-apply',
        meta: {
            title: '续单审核',
            menuName: '续单审核',
            menuPermission: 'continued-apply'
        },
        component: () => import('@/views/leader/continued-apply')
    },
    {
        path: '/leader/clerk-manage',
        meta: {
            title: '店员管理',
            menuName: '店员管理',
            menuPermission: 'clerk-manage'
        },
        component: () => import('@/views/leader/clerk/clerk-manage/clerk-manage')
    },
    {
        path: '/leader/clerk-performance',
        meta: {
            title: '店员业绩',
            menuName: '店员业绩',
            menuPermission: 'clerk-performance'
        },
        component: () => import('@/views/leader/clerk/clerk-performance')
    },
    {
        path: '/leader/clerk-category-examine-check',
        meta: {
            title: '店员技能审核',
            menuName: '店员技能审核',
            menuPermission: 'clerk_category_examine_check'
        },
        component: () => import('@/views/leader/clerk/clerk-category-check/clerk-category-check-list')
    },
    {
        path: '/leader/clerk-category-examine-check-detail',
        meta: {
            title: '店员技能审核详情',
            menuName: '店员技能审核详情',
            menuPermission: 'clerk_category_examine_check'
        },
        component: () => import('@/views/leader/clerk/clerk-category-check/clerk-category-check-detail')
    },
    // ==========================================================  客服  ==========================================================
    {
        path: '/kf/order/list',
        meta: {
            title: '订单列表',
            menuName: '订单',
            menuPermission: 'order'
        },
        component: () => import('@/views/kf/order/order-list')
    },
    {
        path: '/kf/order/detail/:id',
        meta: {
            title: '订单详情',
            menuName: '订单',
            menuPermission: 'order'
        },
        component: () => import('@/views/kf/order/order-detail')
    },
    {
        path: '/kf/order/rate-list',
        meta: {
            title: '订单评价',
            menuName: '订单评价',
            menuPermission: 'order-rate'
        },
        component: () => import('@/views/kf/order/order-rate-list')
    },
    {
        path: '/kf/order/rate-detail/:id',
        meta: {
            title: '订单评价详情',
            menuName: '订单评价',
            menuPermission: 'order-rate'
        },
        component: () => import('@/views/kf/order/order-rate-detail')
    },
    {
        path: '/kf/order/complain-list',
        meta: {
            title: '订单投诉',
            menuName: '订单投诉',
            menuPermission: 'order-complain'
        },
        component: () => import('@/views/kf/order/order-complain-list')
    },
    {
        path: '/kf/order/complain-detail/:id',
        meta: {
            title: '订单投诉详情',
            menuName: '订单投诉',
            menuPermission: 'order-complain'
        },
        component: () => import('@/views/kf/order/order-complain-detail')
    },
    {
        path: '/kf/wages',
        meta: {
            title: '工资',
            menuName: '工资',
            menuPermission: 'wages'
        },
        component: () => import('@/views/kf/kf-wages')
    },
    {
        path: '/kf/order-entry',
        meta: {
            title: '订单录入',
            menuName: '订单录入',
            menuPermission: 'order-entry'
        },
        component: () => import('@/views/kf/order-entry')
    },
    {
        path: '/kf/order/out-order-list',
        meta: {
            title: '外部订单',
            menuName: '外部订单',
            menuPermission: 'out-order'
        },
        component: () => import('@/views/kf/order/out-order-list')
    },
    {
        path: '/kf/order/out-order-detail/:id',
        meta: {
            title: '外部订单详情',
            menuName: '外部订单',
            menuPermission: 'out-order'
        },
        component: () => import('@/views/kf/order/out-order-detail')
    },
    {
        path: '/kf/out-order-entry',
        meta: {
            title: '添加外部订单',
            menuName: '外部订单',
            menuPermission: 'out-order'
        },
        component: () => import('@/views/kf/out-order-entry')
    },
    {
        path: '/kf/out-order-update/:id',
        meta: {
            title: '修改外部订单',
            menuName: '外部订单',
            menuPermission: 'out-order'
        },
        component: () => import('@/views/kf/out-order-update')
    },
    {
        path: '/kf/user/user-list',
        meta: {
            title: '用户管理',
            menuName: '用户管理',
            menuPermission: 'user-manage'
        },
        component: () => import('@/views/kf/user/user-list')
    },
    {
        path: '/kf/user/detail/:id',
        meta: {
            title: '用户详情',
            menuName: '用户管理',
            menuPermission: 'user-manage'
        },
        component: () => import('@/views/kf/user/user-detail')
    },
    {
        path: '/kf/first-order',
        meta: {
            title: '首单体验',
            menuName: '首单体验',
            menuPermission: 'first-order'
        },
        component: () => import('@/views/kf/first-order')
    },
    {
        path: '/kf/order/continued-apply',
        meta: {
            title: '续单审核',
            menuName: '续单审核',
            menuPermission: 'continued-apply'
        },
        component: () => import('@/views/kf/order/continued-apply')
    },
    {
        path: '/kf/clerkRespondUser/detail/:id',
        meta: {
            title: '呼叫店员详情',
            menuName: '呼叫店员详情',
            menuPermission: 'order'
        },
        component: () => import('@/views/kf/clerkRespondUser/detail')
    },
    {
        path: '/kf/order/clerk-order-list',
        meta: {
            title: '店员权益订单',
            menuName: '店员权益订单',
            menuPermission: 'clerk-order'
        },
        component: () => import('@/views/kf/order/clerk-order-list')
    },
    {
        path: '/kf/order/clerk-order-detail/:id',
        meta: {
            title: '店员权益订单详情',
            menuName: '店员权益订单详情',
            menuPermission: 'clerk-order'
        },
        component: () => import('@/views/kf/order/clerk-order-detail')
    },
    // ==========================================================  管理员  ==========================================================
    {
        path: '/admin/order/list',
        meta: {
            title: '订单列表',
            menuName: '订单',
            menuPermission: 'order'
        },
        component: () => import('@/views/admin/order/order-list')
    },
    {
        path: '/admin/order/detail/:id',
        meta: {
            title: '订单详情',
            menuName: '订单',
            menuPermission: 'order'
        },
        component: () => import('@/views/admin/order/order-detail')
    },
    {
        path: '/admin/order/rate-list',
        meta: {
            title: '订单评价',
            menuName: '订单评价',
            menuPermission: 'order-rate'
        },
        component: () => import('@/views/admin/order/order-rate-list')
    },
    {
        path: '/admin/order/rate-detail/:id',
        meta: {
            title: '订单评价详情',
            menuName: '订单评价',
            menuPermission: 'order-rate'
        },
        component: () => import('@/views/admin/order/order-rate-detail')
    },
    {
        path: '/admin/order/complain-list',
        meta: {
            title: '订单投诉',
            menuName: '订单投诉',
            menuPermission: 'order-complain'
        },
        component: () => import('@/views/admin/order/order-complain-list')
    },
    {
        path: '/admin/order/complain-detail/:id',
        meta: {
            title: '订单投诉详情',
            menuName: '订单投诉',
            menuPermission: 'order-complain'
        },
        component: () => import('@/views/admin/order/order-complain-detail')
    },
    {
        path: '/admin/clerk-apply-list',
        meta: {
            title: '新店员申请',
            menuName: '新店员申请',
            menuPermission: 'clerk-apply'
        },
        component: () => import('@/views/admin/clerk/clerk-apply/clerk-apply-list')
    },
    {
        path: '/admin/clerk-apply/detail/:id',
        meta: {
            title: '新店员申请详情',
            menuName: '新店员申请',
            menuPermission: 'clerk-apply'
        },
        component: () => import('@/views/admin/clerk/clerk-apply/clerk-apply-detail')
    },
    {
        path: '/admin/check-list',
        meta: {
            title: '店员资料审核',
            menuName: '店员资料审核',
            menuPermission: 'check-list'
        },
        component: () => import('@/views/admin/clerk/clerk-check/check-list')
    },
    {
        path: '/admin/check-detail',
        meta: {
            title: '店员资料审核详情',
            menuName: '店员资料审核',
            menuPermission: 'check-list'
        },
        component: () => import('@/views/admin/clerk/clerk-check/check-detail')
    },
    {
        path: '/admin/leader-wages',
        meta: {
            title: '组长工资',
            menuName: '组长工资',
            menuPermission: 'leader-wages'
        },
        component: () => import('@/views/admin/leader-wages')
    },
    {
        path: '/admin/kf-wages',
        meta: {
            title: '客服工资',
            menuName: '客服工资',
            menuPermission: 'kf-wages'
        },
        component: () => import('@/views/admin/kf-wages')
    },
    {
        path: '/admin/clerk-performance',
        meta: {
            title: '店员业绩',
            menuName: '店员业绩',
            menuPermission: 'clerk-performance'
        },
        component: () => import('@/views/admin/clerk/clerk-performance')
    },
    {
        path: '/admin/post-list',
        meta: {
            title: '动态管理',
            menuName: '动态管理',
            menuPermission: 'post-list'
        },
        component: () => import('@/views/admin/post-list')
    },
    {
        path: '/admin/user/user-list',
        meta: {
            title: '用户管理',
            menuName: '用户管理',
            menuPermission: 'user-manage'
        },
        component: () => import('@/views/admin/user/user-list')
    },
    {
        path: '/admin/user/detail/:id',
        meta: {
            title: '用户详情',
            menuName: '用户管理',
            menuPermission: 'user-manage'
        },
        component: () => import('@/views/admin/user/user-detail')
    },
    {
        path: '/admin/order/continued-apply',
        meta: {
            title: '续单审核',
            menuName: '续单审核',
            menuPermission: 'continued-apply'
        },
        component: () => import('@/views/admin/order/continued-apply')
    },
    {
        path: '/admin/clerk-manage',
        meta: {
            title: '店员管理',
            menuName: '店员管理',
            menuPermission: 'clerk-performance'
        },
        component: () => import('@/views/admin/clerk/clerk-manage/clerk-manage')
    },
    {
        path: '/admin/tech-support-visitor-list',
        meta: {
            title: '开店咨询',
            menuName: '开店咨询',
            menuPermission: 'tech-support-visitor'
        },
        component: ()=> import('@/views/admin/tech-support-visitor-list')
    },
    {
        path: '/admin/clerk-category-examine-check',
        meta: {
            title: '店员技能审核',
            menuName: '店员技能审核',
            menuPermission: 'clerk_category_examine_check'
        },
        component: () => import('@/views/admin/clerk/clerk-category-check/clerk-category-check-list')
    },
    {
        path: '/admin/clerk-category-examine-check-detail',
        meta: {
            title: '店员技能审核详情',
            menuName: '店员技能审核详情',
            menuPermission: 'clerk_category_examine_check'
        },
        component: () => import('@/views/admin/clerk/clerk-category-check/clerk-category-check-detail')
    },
    {
        path: '/admin/purchase-order/list',
        meta: {
            title: '团购订单',
            menuName: '团购订单',
            menuPermission: 'purchase_order'
        },
        component: () => import('@/views/admin/order/purchase-order-list')
    },
    {
        path: '/admin/purchase-order/detail/:id',
        meta: {
            title: '团购订单详情',
            menuName: '团购订单详情',
            menuPermission: 'purchase_order'
        },
        component: () => import('@/views/admin/order/purchase-order-detail')
    },
    {
        path: '/admin/purchase-order/rate-list',
        meta: {
            title: '团购评价',
            menuName: '团购评价',
            menuPermission: 'purchase_order_rate'
        },
        component: () => import('@/views/admin/order/purchase-order-rate-list')
    },
    {
        path: '/admin/purchase-order/rate-detail/:id',
        meta: {
            title: '团购评价详情',
            menuName: '团购评价详情',
            menuPermission: 'purchase_order_rate'
        },
        component: () => import('@/views/admin/order/purchase-order-rate-detail')
    },
    {
        path: '/admin/distributor-pay-order/list',
        meta: {
            title: '分销入驻订单',
            menuName: '分销入驻订单',
            menuPermission: 'distributor-pay-order'
        },
        component: () => import('@/views/admin/order/distributor-pay-order-list')
    },
    {
        path: '/admin/distributor-pay-order/detail/:id',
        meta: {
            title: '分销入驻订单详情',
            menuName: '分销入驻订单详情',
            menuPermission: 'distributor-pay-order'
        },
        component: () => import('@/views/admin/order/distributor-pay-order-detail')
    },
    {
        path: '/admin/notice/notice-list',
        meta: {
            title: '公告列表',
            menuName: '公告列表',
            menuPermission: 'notice-list'
        },
        component: () => import('@/views/admin/notice/notice-list')
    },
    {
        path: '/admin/notice/notice-detail/:id',
        meta: {
            title: '公告详情',
            menuName: '公告详情',
            menuPermission: 'notice-list'
        },
        component: () => import('@/views/admin/notice/notice-detail')
    },
    {
        path: '/admin/notice/log-list',
        meta: {
            title: '日志列表',
            menuName: '日志列表',
            menuPermission: 'log-list'
        },
        component: () => import('@/views/admin/notice/log-list')
    },
    {
        path: '/admin/notice/log-detail/:id',
        meta: {
            title: '日志详情',
            menuName: '日志详情',
            menuPermission: 'log-list'
        },
        component: () => import('@/views/admin/notice/log-detail')
    },
    {
        path: '/admin/notice/log-message',
        meta: {
            title: '消息中心',
            menuName: '消息中心',
            menuPermission: 'log-list'
        },
        component: () => import('@/views/admin/notice/log-message')
    },
    {
        name: 'register',
        path: '/register',
        meta: {
            title: '注册帐号'
        },
        component: () => import('@/views/register')
    },
    {
        path: '/agreement',
        meta: {
            title: '认证协议'
        },
        component: () => import('@/views/agreement')
    },
    {
        path: '/balance',
        meta: {
            title: '账号余额'
        },
        component: () => import('@/views/balance')
    },
    {
        path: '/chat/:id',
        meta: {
            title: '聊天'
        },
        component: () => import('@/views/chat')
    },
    {
        path: '/clerk/location/address',
        meta: {
            title: '选择地址',
            menuName: '我的资料',
            menuPermission: 'info'
        },
        component: () => import('@/views/clerk/location/address')
    },

    {
        path: '/clerk/location/location',
        meta: {
            title: '地图',
            menuName: '我的资料',
            menuPermission: 'info'
        },
        component: () => import('@/views/clerk/location/location')
    },
    {
        path: '/clerk/chat/roomListAndOnline',
        meta: {
            title: '聊天消息',
            menuName: '聊天',
            menuPermission: 'chat'
        },
        component: () => import('@/views/2184/clerk/chat/roomListAndOnline')
    },
    {
        name: 'account-verify',
        path: '/account-verify',
        meta: {
            title: '验证手机号'
        },
        component: ()=>import('@/views/account-verify.vue')
    }
]

